import { setOrgAuthFetchInterceptor } from "@solomon-apps/shared";

import { resolveOrgAuthMock } from "./mockApi";

/**
 * SIM data layer for shared services. `orgApiFetch` checks sim mode itself,
 * but shared services (the org-members client behind `/team`) call the shared
 * `orgAuthFetch` directly, so the mock registry is also registered there.
 * Safe to call unconditionally: `resolveOrgAuthMock` returns `null` when sim
 * mode is off, so live traffic is untouched.
 */
export function registerSimMockLayer(): void {
    setOrgAuthFetchInterceptor(resolveOrgAuthMock);
}
